/* AUTH */

// login
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE'
export const LOGOUT = 'auth/LOGOUT'
// token refresh
export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST'
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS'
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE'

/* END AUTH */

/* EASYMS ORGANIZATIONS */

export const EASYMS_ORGANIZATIONS_FETCH_REQUEST = 'EASYMS_ORGANIZATIONS_FETCH_REQUEST'
export const EASYMS_ORGANIZATIONS_FETCH_SUCCESS = 'EASYMS_ORGANIZATIONS_FETCH_SUCCESS'
export const EASYMS_ORGANIZATIONS_FETCH_FAILURE = 'EASYMS_ORGANIZATIONS_FETCH_FAILURE'

/* END EASYMS ORGANIZATIONS */


/* BOOKING */

// categories action types
export const B_CATEGORIES_FETCH_REQUEST = 'B_CATEGORIES_FETCH_REQUEST'
export const B_CATEGORIES_FETCH_SUCCESS = 'B_CATEGORIES_FETCH_SUCCESS'
export const B_CATEGORIES_FETCH_FAILURE = 'B_CATEGORIES_FETCH_FAILURE'
export const B_CATEGORIES_SAVE_SUCCESS = 'B_CATEGORIES_SAVE_SUCCESS'
export const B_CATEGORIES_SAVE_FAILURE = 'B_CATEGORIES_SAVE_FAILURE'
export const B_CATEGORIES_DELETE_SUCCESS = 'B_CATEGORIES_DELETE_SUCCESS'
export const B_CATEGORIES_DELETE_FAILURE = 'B_CATEGORIES_DELETE_FAILURE'
export const B_CATEGORIES_IMPORT_SUCCESS = 'B_CATEGORIES_IMPORT_SUCCESS'
export const B_CATEGORIES_IMPORT_FAILURE = 'B_CATEGORIES_IMPORT_FAILURE'
// organizations action types
export const B_ORGANIZATIONS_FETCH_REQUEST = 'B_ORGANIZATIONS_FETCH_REQUEST'
export const B_ORGANIZATIONS_FETCH_SUCCESS = 'B_ORGANIZATIONS_FETCH_SUCCESS'
export const B_ORGANIZATIONS_FETCH_FAILURE = 'B_ORGANIZATIONS_FETCH_FAILURE'
export const B_ORGANIZATIONS_SAVE_SUCCESS = 'B_ORGANIZATIONS_SAVE_SUCCESS'
export const B_ORGANIZATIONS_SAVE_FAILURE = 'B_ORGANIZATIONS_SAVE_FAILURE'
export const B_ORGANIZATIONS_UPDATE_SUCCESS = 'B_ORGANIZATIONS_UPDATE_SUCCESS'
export const B_ORGANIZATIONS_UPDATE_FAILURE = 'B_ORGANIZATIONS_UPDATE_FAILURE'
export const B_ORGANIZATIONS_DELETE_SUCCESS = 'B_ORGANIZATIONS_DELETE_SUCCESS'
export const B_ORGANIZATIONS_DELETE_FAILURE = 'B_ORGANIZATIONS_DELETE_FAILURE'
// rates action types
export const B_RATES_FETCH_REQUEST = 'B_RATES_FETCH_REQUEST'
export const B_RATES_FETCH_SUCCESS = 'B_RATES_FETCH_SUCCESS'
export const B_RATES_FETCH_FAILURE = 'B_RATES_FETCH_FAILURE'
export const B_RATES_SAVE_SUCCESS = 'B_RATES_SAVE_SUCCESS'
export const B_RATES_SAVE_FAILURE = 'B_RATES_SAVE_FAILURE'
export const B_RATES_DELETE_SUCCESS = 'B_RATES_DELETE_SUCCESS'
export const B_RATES_DELETE_FAILURE = 'B_RATES_DELETE_FAILURE'
export const B_RATES_IMPORT_SUCCESS = 'B_RATES_IMPORT_SUCCESS'
export const B_RATES_IMPORT_FAILURE = 'B_RATES_IMPORT_FAILURE'
// currentOrganization action types
export const B_CURRENT_ORGANIZATION_CHANGE = 'B_CURRENT_ORGANIZATION_CHANGE'
//sync
export const B_PUSH_YEAR_PRICES_REQUEST = 'B_PUSH_YEAR_PRICES_REQUEST'
export const B_PUSH_YEAR_PRICES_SUCCESS = 'B_PUSH_YEAR_PRICES_SUCCESS'
export const B_PUSH_YEAR_PRICES_FAILURE = 'B_PUSH_YEAR_PRICES_FAILURE'
export const B_PUSH_YEAR_RESTRICTIONS_REQUEST = 'B_PUSH_YEAR_RESTRICTIONS_REQUEST'
export const B_PUSH_YEAR_RESTRICTIONS_SUCCESS = 'B_PUSH_YEAR_RESTRICTIONS_SUCCESS'
export const B_PUSH_YEAR_RESTRICTIONS_FAILURE = 'B_PUSH_YEAR_RESTRICTIONS_FAILURE'
export const B_INVENTORY_AVAILABILITY_REQUEST = 'B_INVENTORY_AVAILABILITY_REQUEST'
export const B_INVENTORY_AVAILABILITY_SUCCESS = 'B_INVENTORY_AVAILABILITY_SUCCESS'
export const B_INVENTORY_AVAILABILITY_FAILURE = 'B_INVENTORY_AVAILABILITY_FAILURE'
export const B_INVENTORY_ORDER_REQUEST = 'B_INVENTORY_ORDER_REQUEST'
export const B_INVENTORY_ORDER_SUCCESS = 'B_INVENTORY_ORDER_SUCCESS'
export const B_INVENTORY_ORDER_FAILURE = 'B_INVENTORY_ORDER_FAILURE'
export const B_INVENTORY_OTELMS_REQUEST = 'B_INVENTORY_OTELMS_REQUEST'
export const B_INVENTORY_OTELMS_SUCCESS = 'B_INVENTORY_OTELMS_SUCCESS'
export const B_INVENTORY_OTELMS_FAILURE = 'B_INVENTORY_OTELMS_FAILURE'
export const B_LOAD_BASED_ON_RESERVATION_SUMMARY_REQUEST = 'B_LOAD_BASED_ON_RESERVATION_SUMMARY_REQUEST'
export const B_LOAD_BASED_ON_RESERVATION_SUMMARY_SUCCESS = 'B_LOAD_BASED_ON_RESERVATION_SUMMARY_SUCCESS'
export const B_LOAD_BASED_ON_RESERVATION_SUMMARY_FAILURE = 'B_LOAD_BASED_ON_RESERVATION_SUMMARY_FAILURE'

// easyms
export const B_EASYMS_CATEGORIES_FETCH_REQUEST = 'B_EASYMS_CATEGORIES_FETCH_REQUEST'
export const B_EASYMS_CATEGORIES_FETCH_SUCCESS = 'B_EASYMS_CATEGORIES_FETCH_SUCCESS'
export const B_EASYMS_CATEGORIES_FETCH_FAILURE = 'B_EASYMS_CATEGORIES_FETCH_FAILURE'
export const B_EASYMS_RATES_FETCH_REQUEST = 'B_EASYMS_RATES_FETCH_REQUEST'
export const B_EASYMS_RATES_FETCH_SUCCESS = 'B_EASYMS_RATES_FETCH_SUCCESS'
export const B_EASYMS_RATES_FETCH_FAILURE = 'B_EASYMS_RATES_FETCH_FAILURE'
/* END BOOKING */

/* HOTELS24 */

// categories action types
export const H24_CATEGORIES_FETCH_REQUEST = 'H24_CATEGORIES_FETCH_REQUEST'
export const H24_CATEGORIES_FETCH_SUCCESS = 'H24_CATEGORIES_FETCH_SUCCESS'
export const H24_CATEGORIES_FETCH_FAILURE = 'H24_CATEGORIES_FETCH_FAILURE'
export const H24_CATEGORIES_SAVE_SUCCESS = 'H24_CATEGORIES_SAVE_SUCCESS'
export const H24_CATEGORIES_SAVE_FAILURE = 'H24_CATEGORIES_SAVE_FAILURE'
export const H24_CATEGORIES_DELETE_SUCCESS = 'H24_CATEGORIES_DELETE_SUCCESS'
export const H24_CATEGORIES_DELETE_FAILURE = 'H24_CATEGORIES_DELETE_FAILURE'
export const H24_CATEGORIES_IMPORT_SUCCESS = 'H24_CATEGORIES_IMPORT_SUCCESS'
export const H24_CATEGORIES_IMPORT_FAILURE = 'H24_CATEGORIES_IMPORT_FAILURE'
// organizations action types
export const H24_ORGANIZATIONS_FETCH_REQUEST = 'H24_ORGANIZATIONS_FETCH_REQUEST'
export const H24_ORGANIZATIONS_FETCH_SUCCESS = 'H24_ORGANIZATIONS_FETCH_SUCCESS'
export const H24_ORGANIZATIONS_FETCH_FAILURE = 'H24_ORGANIZATIONS_FETCH_FAILURE'
export const H24_ORGANIZATIONS_SAVE_SUCCESS = 'H24_ORGANIZATIONS_SAVE_SUCCESS'
export const H24_ORGANIZATIONS_SAVE_FAILURE = 'H24_ORGANIZATIONS_SAVE_FAILURE'
export const H24_ORGANIZATIONS_UPDATE_SUCCESS = 'H24_ORGANIZATIONS_UPDATE_SUCCESS'
export const H24_ORGANIZATIONS_UPDATE_FAILURE = 'H24_ORGANIZATIONS_UPDATE_FAILURE'
export const H24_ORGANIZATIONS_DELETE_SUCCESS = 'H24_ORGANIZATIONS_DELETE_SUCCESS'
export const H24_ORGANIZATIONS_DELETE_FAILURE = 'H24_ORGANIZATIONS_DELETE_FAILURE'
// rates action types
export const H24_RATES_FETCH_REQUEST = 'H24_RATES_FETCH_REQUEST'
export const H24_RATES_FETCH_SUCCESS = 'H24_RATES_FETCH_SUCCESS'
export const H24_RATES_FETCH_FAILURE = 'H24_RATES_FETCH_FAILURE'
export const H24_RATES_SAVE_SUCCESS = 'H24_RATES_SAVE_SUCCESS'
export const H24_RATES_SAVE_FAILURE = 'H24_RATES_SAVE_FAILURE'
export const H24_RATES_DELETE_SUCCESS = 'H24_RATES_DELETE_SUCCESS'
export const H24_RATES_DELETE_FAILURE = 'H24_RATES_DELETE_FAILURE'
export const H24_RATES_IMPORT_SUCCESS = 'H24_RATES_IMPORT_SUCCESS'
export const H24_RATES_IMPORT_FAILURE = 'H24_RATES_IMPORT_FAILURE'
// currentOrganization action types
export const H24_CURRENT_ORGANIZATION_CHANGE = 'H24_CURRENT_ORGANIZATION_CHANGE'
//sync
export const H24_PUSH_YEAR_PRICES_REQUEST = 'H24_PUSH_YEAR_PRICES_REQUEST'
export const H24_PUSH_YEAR_PRICES_SUCCESS = 'H24_PUSH_YEAR_PRICES_SUCCESS'
export const H24_PUSH_YEAR_PRICES_FAILURE = 'H24_PUSH_YEAR_PRICES_FAILURE'
export const H24_PUSH_YEAR_RESTRICTIONS_REQUEST = 'H24_PUSH_YEAR_RESTRICTIONS_REQUEST'
export const H24_PUSH_YEAR_RESTRICTIONS_SUCCESS = 'H24_PUSH_YEAR_RESTRICTIONS_SUCCESS'
export const H24_PUSH_YEAR_RESTRICTIONS_FAILURE = 'H24_PUSH_YEAR_RESTRICTIONS_FAILURE'
export const H24_INVENTORY_AVAILABILITY_REQUEST = 'H24_INVENTORY_AVAILABILITY_REQUEST'
export const H24_INVENTORY_AVAILABILITY_SUCCESS = 'H24_INVENTORY_AVAILABILITY_SUCCESS'
export const H24_INVENTORY_AVAILABILITY_FAILURE = 'H24_INVENTORY_AVAILABILITY_FAILURE'

// easyms
export const H24_EASYMS_CATEGORIES_FETCH_REQUEST = 'H24_EASYMS_CATEGORIES_FETCH_REQUEST'
export const H24_EASYMS_CATEGORIES_FETCH_SUCCESS = 'H24_EASYMS_CATEGORIES_FETCH_SUCCESS'
export const H24_EASYMS_CATEGORIES_FETCH_FAILURE = 'H24_EASYMS_CATEGORIES_FETCH_FAILURE'
export const H24_EASYMS_RATES_FETCH_REQUEST = 'H24_EASYMS_RATES_FETCH_REQUEST'
export const H24_EASYMS_RATES_FETCH_SUCCESS = 'H24_EASYMS_RATES_FETCH_SUCCESS'
export const H24_EASYMS_RATES_FETCH_FAILURE = 'H24_EASYMS_RATES_FETCH_FAILURE'
/* END HOTELS24 */

/* HOSTELWORLD */

// categories action types
export const HW_CATEGORIES_FETCH_REQUEST = 'HW_CATEGORIES_FETCH_REQUEST'
export const HW_CATEGORIES_FETCH_SUCCESS = 'HW_CATEGORIES_FETCH_SUCCESS'
export const HW_CATEGORIES_FETCH_FAILURE = 'HW_CATEGORIES_FETCH_FAILURE'
export const HW_CATEGORIES_SAVE_SUCCESS = 'HW_CATEGORIES_SAVE_SUCCESS'
export const HW_CATEGORIES_SAVE_FAILURE = 'HW_CATEGORIES_SAVE_FAILURE'
export const HW_CATEGORIES_DELETE_SUCCESS = 'HW_CATEGORIES_DELETE_SUCCESS'
export const HW_CATEGORIES_DELETE_FAILURE = 'HW_CATEGORIES_DELETE_FAILURE'
export const HW_CATEGORIES_IMPORT_SUCCESS = 'HW_CATEGORIES_IMPORT_SUCCESS'
export const HW_CATEGORIES_IMPORT_FAILURE = 'HW_CATEGORIES_IMPORT_FAILURE'
// organizations action types
export const HW_ORGANIZATIONS_FETCH_REQUEST = 'HW_ORGANIZATIONS_FETCH_REQUEST'
export const HW_ORGANIZATIONS_FETCH_SUCCESS = 'HW_ORGANIZATIONS_FETCH_SUCCESS'
export const HW_ORGANIZATIONS_FETCH_FAILURE = 'HW_ORGANIZATIONS_FETCH_FAILURE'
export const HW_ORGANIZATIONS_SAVE_SUCCESS = 'HW_ORGANIZATIONS_SAVE_SUCCESS'
export const HW_ORGANIZATIONS_SAVE_FAILURE = 'HW_ORGANIZATIONS_SAVE_FAILURE'
export const HW_ORGANIZATIONS_UPDATE_SUCCESS = 'HW_ORGANIZATIONS_UPDATE_SUCCESS'
export const HW_ORGANIZATIONS_UPDATE_FAILURE = 'HW_ORGANIZATIONS_UPDATE_FAILURE'
export const HW_ORGANIZATIONS_DELETE_SUCCESS = 'HW_ORGANIZATIONS_DELETE_SUCCESS'
export const HW_ORGANIZATIONS_DELETE_FAILURE = 'HW_ORGANIZATIONS_DELETE_FAILURE'
// rates action types
export const HW_RATES_FETCH_REQUEST = 'HW_RATES_FETCH_REQUEST'
export const HW_RATES_FETCH_SUCCESS = 'HW_RATES_FETCH_SUCCESS'
export const HW_RATES_FETCH_FAILURE = 'HW_RATES_FETCH_FAILURE'
export const HW_RATES_SAVE_SUCCESS = 'HW_RATES_SAVE_SUCCESS'
export const HW_RATES_SAVE_FAILURE = 'HW_RATES_SAVE_FAILURE'
export const HW_RATES_DELETE_SUCCESS = 'HW_RATES_DELETE_SUCCESS'
export const HW_RATES_DELETE_FAILURE = 'HW_RATES_DELETE_FAILURE'
// currentOrganization action types
export const HW_CURRENT_ORGANIZATION_CHANGE = 'HW_CURRENT_ORGANIZATION_CHANGE'
//sync
export const HW_PUSH_YEAR_PRICES_REQUEST = 'HW_PUSH_YEAR_PRICES_REQUEST'
export const HW_PUSH_YEAR_PRICES_SUCCESS = 'HW_PUSH_YEAR_PRICES_SUCCESS'
export const HW_PUSH_YEAR_PRICES_FAILURE = 'HW_PUSH_YEAR_PRICES_FAILURE'
export const HW_CHECK_AND_PULL_ORDERS_REQUEST = 'HW_CHECK_AND_PULL_ORDERS_REQUEST'
export const HW_CHECK_AND_PULL_ORDERS_SUCCESS = 'HW_CHECK_AND_PULL_ORDERS_SUCCESS'
export const HW_CHECK_AND_PULL_ORDERS_FAILURE = 'HW_CHECK_AND_PULL_ORDERS_FAILURE'
export const HW_INVENTORY_AVAILABILITY_REQUEST = 'HW_INVENTORY_AVAILABILITY_REQUEST'
export const HW_INVENTORY_AVAILABILITY_SUCCESS = 'HW_INVENTORY_AVAILABILITY_SUCCESS'
export const HW_INVENTORY_AVAILABILITY_FAILURE = 'HW_INVENTORY_AVAILABILITY_FAILURE'

// easyms
export const HW_EASYMS_CATEGORIES_FETCH_REQUEST = 'HW_EASYMS_CATEGORIES_FETCH_REQUEST'
export const HW_EASYMS_CATEGORIES_FETCH_SUCCESS = 'HW_EASYMS_CATEGORIES_FETCH_SUCCESS'
export const HW_EASYMS_CATEGORIES_FETCH_FAILURE = 'HW_EASYMS_CATEGORIES_FETCH_FAILURE'
export const HW_EASYMS_RATES_FETCH_REQUEST = 'HW_EASYMS_RATES_FETCH_REQUEST'
export const HW_EASYMS_RATES_FETCH_SUCCESS = 'HW_EASYMS_RATES_FETCH_SUCCESS'
export const HW_EASYMS_RATES_FETCH_FAILURE = 'HW_EASYMS_RATES_FETCH_FAILURE'

/* END HOSTELWORLD */

/* DOBOVO */

// apartments action types
export const DOBOVO_APARTMENTS_FETCH_REQUEST = 'DOBOVO_APARTMENTS_FETCH_REQUEST'
export const DOBOVO_APARTMENTS_FETCH_SUCCESS = 'DOBOVO_APARTMENTS_FETCH_SUCCESS'
export const DOBOVO_APARTMENTS_FETCH_FAILURE = 'DOBOVO_APARTMENTS_FETCH_FAILURE'
export const DOBOVO_APARTMENTS_SAVE_SUCCESS = 'DOBOVO_APARTMENTS_SAVE_SUCCESS'
export const DOBOVO_APARTMENTS_SAVE_FAILURE = 'DOBOVO_APARTMENTS_SAVE_FAILURE'
export const DOBOVO_APARTMENTS_DELETE_SUCCESS = 'DOBOVO_APARTMENTS_DELETE_SUCCESS'
export const DOBOVO_APARTMENTS_DELETE_FAILURE = 'DOBOVO_APARTMENTS_DELETE_FAILURE'
export const DOBOVO_APARTMENTS_IMPORT_SUCCESS = 'DOBOVO_APARTMENTS_IMPORT_SUCCESS'
export const DOBOVO_APARTMENTS_IMPORT_FAILURE = 'DOBOVO_APARTMENTS_IMPORT_FAILURE'
// organizations action types
export const DOBOVO_ORGANIZATIONS_FETCH_REQUEST = 'DOBOVO_ORGANIZATIONS_FETCH_REQUEST'
export const DOBOVO_ORGANIZATIONS_FETCH_SUCCESS = 'DOBOVO_ORGANIZATIONS_FETCH_SUCCESS'
export const DOBOVO_ORGANIZATIONS_FETCH_FAILURE = 'DOBOVO_ORGANIZATIONS_FETCH_FAILURE'
export const DOBOVO_ORGANIZATIONS_SAVE_SUCCESS = 'DOBOVO_ORGANIZATIONS_SAVE_SUCCESS'
export const DOBOVO_ORGANIZATIONS_SAVE_FAILURE = 'DOBOVO_ORGANIZATIONS_SAVE_FAILURE'
export const DOBOVO_ORGANIZATIONS_UPDATE_SUCCESS = 'DOBOVO_ORGANIZATIONS_UPDATE_SUCCESS'
export const DOBOVO_ORGANIZATIONS_UPDATE_FAILURE = 'DOBOVO_ORGANIZATIONS_UPDATE_FAILURE'
export const DOBOVO_ORGANIZATIONS_DELETE_SUCCESS = 'DOBOVO_ORGANIZATIONS_DELETE_SUCCESS'
export const DOBOVO_ORGANIZATIONS_DELETE_FAILURE = 'DOBOVO_ORGANIZATIONS_DELETE_FAILURE'
// currentOrganization action types
export const DOBOVO_CURRENT_ORGANIZATION_CHANGE = 'DOBOVO_CURRENT_ORGANIZATION_CHANGE'
//sync
export const DOBOVO_PUSH_YEAR_PRICES_REQUEST = 'DOBOVO_PUSH_YEAR_PRICES_REQUEST'
export const DOBOVO_PUSH_YEAR_PRICES_SUCCESS = 'DOBOVO_PUSH_YEAR_PRICES_SUCCESS'
export const DOBOVO_PUSH_YEAR_PRICES_FAILURE = 'DOBOVO_PUSH_YEAR_PRICES_FAILURE'
export const DOBOVO_PUSH_YEAR_RESTRICTIONS_REQUEST = 'DOBOVO_PUSH_YEAR_RESTRICTIONS_REQUEST'
export const DOBOVO_PUSH_YEAR_RESTRICTIONS_SUCCESS = 'DOBOVO_PUSH_YEAR_RESTRICTIONS_SUCCESS'
export const DOBOVO_PUSH_YEAR_RESTRICTIONS_FAILURE = 'DOBOVO_PUSH_YEAR_RESTRICTIONS_FAILURE'
export const DOBOVO_PUSH_YEAR_AVAILABILITY_REQUEST = 'DOBOVO_PUSH_YEAR_AVAILABILITY_REQUEST'
export const DOBOVO_PUSH_YEAR_AVAILABILITY_SUCCESS = 'DOBOVO_PUSH_YEAR_AVAILABILITY_SUCCESS'
export const DOBOVO_PUSH_YEAR_AVAILABILITY_FAILURE = 'DOBOVO_PUSH_YEAR_AVAILABILITY_FAILURE'
export const DOBOVO_SYNCHRONIZE_PROPERTY_REQUEST = 'DOBOVO_SYNCHRONIZE_PROPERTY_REQUEST'
export const DOBOVO_SYNCHRONIZE_PROPERTY_SUCCESS = 'DOBOVO_SYNCHRONIZE_PROPERTY_SUCCESS'
export const DOBOVO_SYNCHRONIZE_PROPERTY_FAILURE = 'DOBOVO_SYNCHRONIZE_PROPERTY_FAILURE'

// easyms
export const DOBOVO_EASYMS_CATEGORIES_FETCH_REQUEST = 'DOBOVO_EASYMS_CATEGORIES_FETCH_REQUEST'
export const DOBOVO_EASYMS_CATEGORIES_FETCH_SUCCESS = 'DOBOVO_EASYMS_CATEGORIES_FETCH_SUCCESS'
export const DOBOVO_EASYMS_CATEGORIES_FETCH_FAILURE = 'DOBOVO_EASYMS_CATEGORIES_FETCH_FAILURE'
export const DOBOVO_EASYMS_RATES_FETCH_REQUEST = 'DOBOVO_EASYMS_RATES_FETCH_REQUEST'
export const DOBOVO_EASYMS_RATES_FETCH_SUCCESS = 'DOBOVO_EASYMS_RATES_FETCH_SUCCESS'
export const DOBOVO_EASYMS_RATES_FETCH_FAILURE = 'DOBOVO_EASYMS_RATES_FETCH_FAILURE'
/* END DOBOVO */

/* EXPEDIA */

// categories action types
export const EXPEDIA_CATEGORIES_FETCH_REQUEST = 'EXPEDIA_CATEGORIES_FETCH_REQUEST'
export const EXPEDIA_CATEGORIES_FETCH_SUCCESS = 'EXPEDIA_CATEGORIES_FETCH_SUCCESS'
export const EXPEDIA_CATEGORIES_FETCH_FAILURE = 'EXPEDIA_CATEGORIES_FETCH_FAILURE'
export const EXPEDIA_CATEGORIES_SAVE_SUCCESS = 'EXPEDIA_CATEGORIES_SAVE_SUCCESS'
export const EXPEDIA_CATEGORIES_SAVE_FAILURE = 'EXPEDIA_CATEGORIES_SAVE_FAILURE'
export const EXPEDIA_CATEGORIES_DELETE_SUCCESS = 'EXPEDIA_CATEGORIES_DELETE_SUCCESS'
export const EXPEDIA_CATEGORIES_DELETE_FAILURE = 'EXPEDIA_CATEGORIES_DELETE_FAILURE'
export const EXPEDIA_CATEGORIES_IMPORT_SUCCESS = 'EXPEDIA_CATEGORIES_IMPORT_SUCCESS'
export const EXPEDIA_CATEGORIES_IMPORT_FAILURE = 'EXPEDIA_CATEGORIES_IMPORT_FAILURE'
// organizations action types
export const EXPEDIA_ORGANIZATIONS_FETCH_REQUEST = 'EXPEDIA_ORGANIZATIONS_FETCH_REQUEST'
export const EXPEDIA_ORGANIZATIONS_FETCH_SUCCESS = 'EXPEDIA_ORGANIZATIONS_FETCH_SUCCESS'
export const EXPEDIA_ORGANIZATIONS_FETCH_FAILURE = 'EXPEDIA_ORGANIZATIONS_FETCH_FAILURE'
export const EXPEDIA_ORGANIZATIONS_SAVE_SUCCESS = 'EXPEDIA_ORGANIZATIONS_SAVE_SUCCESS'
export const EXPEDIA_ORGANIZATIONS_SAVE_FAILURE = 'EXPEDIA_ORGANIZATIONS_SAVE_FAILURE'
export const EXPEDIA_ORGANIZATIONS_UPDATE_SUCCESS = 'EXPEDIA_ORGANIZATIONS_UPDATE_SUCCESS'
export const EXPEDIA_ORGANIZATIONS_UPDATE_FAILURE = 'EXPEDIA_ORGANIZATIONS_UPDATE_FAILURE'
export const EXPEDIA_ORGANIZATIONS_DELETE_SUCCESS = 'EXPEDIA_ORGANIZATIONS_DELETE_SUCCESS'
export const EXPEDIA_ORGANIZATIONS_DELETE_FAILURE = 'EXPEDIA_ORGANIZATIONS_DELETE_FAILURE'
// rates actions types
export const EXPEDIA_RATES_FETCH_REQUEST = 'EXPEDIA_RATES_FETCH_REQUEST'
export const EXPEDIA_RATES_FETCH_SUCCESS = 'EXPEDIA_RATES_FETCH_SUCCESS'
export const EXPEDIA_RATES_FETCH_FAILURE = 'EXPEDIA_RATES_FETCH_FAILURE'
export const EXPEDIA_RATES_SAVE_SUCCESS = 'EXPEDIA_RATES_SAVE_SUCCESS'
export const EXPEDIA_RATES_SAVE_FAILURE = 'EXPEDIA_RATES_SAVE_FAILURE'
export const EXPEDIA_RATES_DELETE_SUCCESS = 'EXPEDIA_RATES_DELETE_SUCCESS'
export const EXPEDIA_RATES_DELETE_FAILURE = 'EXPEDIA_RATES_DELETE_FAILURE'
export const EXPEDIA_RATES_IMPORT_SUCCESS = 'EXPEDIA_RATES_IMPORT_SUCCESS'
export const EXPEDIA_RATES_IMPORT_FAILURE = 'EXPEDIA_RATES_IMPORT_FAILURE'
// currentOrganization action types
export const EXPEDIA_CURRENT_ORGANIZATION_CHANGE = 'EXPEDIA_CURRENT_ORGANIZATION_CHANGE'
//sync
export const EXPEDIA_PUSH_YEAR_PRICES_REQUEST = 'EXPEDIA_PUSH_YEAR_PRICES_REQUEST'
export const EXPEDIA_PUSH_YEAR_PRICES_SUCCESS = 'EXPEDIA_PUSH_YEAR_PRICES_SUCCESS'
export const EXPEDIA_PUSH_YEAR_PRICES_FAILURE = 'EXPEDIA_PUSH_YEAR_PRICES_FAILURE'
export const EXPEDIA_PUSH_YEAR_RESTRICTIONS_REQUEST = 'EXPEDIA_PUSH_YEAR_RESTRICTIONS_REQUEST'
export const EXPEDIA_PUSH_YEAR_RESTRICTIONS_SUCCESS = 'EXPEDIA_PUSH_YEAR_RESTRICTIONS_SUCCESS'
export const EXPEDIA_PUSH_YEAR_RESTRICTIONS_FAILURE = 'EXPEDIA_PUSH_YEAR_RESTRICTIONS_FAILURE'
export const EXPEDIA_PUSH_YEAR_AVAILABILITY_REQUEST = 'EXPEDIA_PUSH_YEAR_AVAILABILITY_REQUEST'
export const EXPEDIA_PUSH_YEAR_AVAILABILITY_SUCCESS = 'EXPEDIA_PUSH_YEAR_AVAILABILITY_SUCCESS'
export const EXPEDIA_PUSH_YEAR_AVAILABILITY_FAILURE = 'EXPEDIA_PUSH_YEAR_AVAILABILITY_FAILURE'
export const EXPEDIA_INVENTORY_AVAILABILITY_REQUEST = 'EXPEDIA_INVENTORY_AVAILABILITY_REQUEST'
export const EXPEDIA_INVENTORY_AVAILABILITY_SUCCESS = 'EXPEDIA_INVENTORY_AVAILABILITY_SUCCESS'
export const EXPEDIA_INVENTORY_AVAILABILITY_FAILURE = 'EXPEDIA_INVENTORY_AVAILABILITY_FAILURE'
export const EXPEDIA_INVENTORY_ORDER_REQUEST = 'EXPEDIA_INVENTORY_ORDER_REQUEST'
export const EXPEDIA_INVENTORY_ORDER_SUCCESS = 'EXPEDIA_INVENTORY_ORDER_SUCCESS'
export const EXPEDIA_INVENTORY_ORDER_FAILURE = 'EXPEDIA_INVENTORY_ORDER_FAILURE'

// easyms
export const EXPEDIA_EASYMS_CATEGORIES_FETCH_REQUEST = 'EXPEDIA_EASYMS_CATEGORIES_FETCH_REQUEST'
export const EXPEDIA_EASYMS_CATEGORIES_FETCH_SUCCESS = 'EXPEDIA_EASYMS_CATEGORIES_FETCH_SUCCESS'
export const EXPEDIA_EASYMS_CATEGORIES_FETCH_FAILURE = 'EXPEDIA_EASYMS_CATEGORIES_FETCH_FAILURE'
export const EXPEDIA_EASYMS_RATES_FETCH_REQUEST = 'EXPEDIA_EASYMS_RATES_FETCH_REQUEST'
export const EXPEDIA_EASYMS_RATES_FETCH_SUCCESS = 'EXPEDIA_EASYMS_RATES_FETCH_SUCCESS'
export const EXPEDIA_EASYMS_RATES_FETCH_FAILURE = 'EXPEDIA_EASYMS_RATES_FETCH_FAILURE'
/* END EXPEDIA */

//omnitec
export const OMNITEC_ORGANIZATIONS_FETCH_REQUEST = 'OMNITEC_ORGANIZATIONS_FETCH_REQUEST'
export const OMNITEC_ORGANIZATIONS_FETCH_SUCCESS = 'OMNITEC_ORGANIZATIONS_FETCH_SUCCESS'
export const OMNITEC_ORGANIZATIONS_FETCH_FAILURE = 'OMNITEC_ORGANIZATIONS_FETCH_FAILURE'
export const OMNITEC_ORGANIZATIONS_SAVE_SUCCESS = 'OMNITEC_ORGANIZATIONS_SAVE_SUCCESS'
export const OMNITEC_ORGANIZATIONS_SAVE_FAILURE = 'OMNITEC_ORGANIZATIONS_SAVE_FAILURE'
export const OMNITEC_ORGANIZATIONS_UPDATE_SUCCESS = 'OMNITEC_ORGANIZATIONS_UPDATE_SUCCESS'
export const OMNITEC_ORGANIZATIONS_UPDATE_FAILURE = 'OMNITEC_ORGANIZATIONS_UPDATE_FAILURE'
export const OMNITEC_ORGANIZATIONS_DELETE_SUCCESS = 'OMNITEC_ORGANIZATIONS_DELETE_SUCCESS'
export const OMNITEC_ORGANIZATIONS_DELETE_FAILURE= 'OMNITEC_ORGANIZATIONS_DELETE_FAILURE'
export const OMNITEC_CURRENT_ORGANIZATION_CHANGE = 'OMNITEC_CURRENT_ORGANIZATION_CHANGE'

export const OMNITEC_LOCKS_FETCH_REQUEST = 'OMNITEC_LOCKS_FETCH_REQUEST'
export const OMNITEC_LOCKS_FETCH_SUCCESS = 'OMNITEC_LOCKS_FETCH_SUCCESS'
export const OMNITEC_LOCKS_FETCH_FAILURE = 'OMNITEC_LOCKS_FETCH_FAILURE'

export const OMNITEC_PRIVATE_ROOMS_FETCH_REQUEST = 'OMNITEC_PRIVATE_ROOMS_FETCH_REQUEST'
export const OMNITEC_PRIVATE_ROOMS_FETCH_SUCCESS = 'OMNITEC_PRIVATE_ROOMS_FETCH_SUCCESS'
export const OMNITEC_PRIVATE_ROOMS_FETCH_FAILURE = 'OMNITEC_PRIVATE_ROOMS_FETCH_FAILURE'
export const OMNITEC_PRIVATE_ROOMS_CREATE_SUCCESS = 'OMNITEC_PRIVATE_ROOMS_CREATE_SUCCESS'
export const OMNITEC_PRIVATE_ROOMS_CREATE_FAILURE = 'OMNITEC_PRIVATE_ROOMS_CREATE_FAILURE'
export const OMNITEC_PRIVATE_ROOMS_DELETE_SUCCESS = 'OMNITEC_PRIVATE_ROOMS_DELETE_SUCCESS'
export const OMNITEC_PRIVATE_ROOMS_DELETE_FAILURE = 'OMNITEC_PRIVATE_ROOMS_DELETE_FAILURE'

export const OMNITEC_COMMON_AREA_FETCH_REQUEST = 'OMNITEC_COMMON_AREA_FETCH_REQUEST'
export const OMNITEC_COMMON_AREA_FETCH_SUCCESS = 'OMNITEC_COMMON_AREA_FETCH_SUCCESS'
export const OMNITEC_COMMON_AREA_FETCH_FAILURE = 'OMNITEC_COMMON_AREA_FETCH_FAILURE'
export const OMNITEC_COMMON_AREA_CREATE_SUCCESS = 'OMNITEC_COMMON_AREA_CREATE_SUCCESS'
export const OMNITEC_COMMON_AREA_CREATE_FAILURE = 'OMNITEC_COMMON_AREA_CREATE_FAILURE'
export const OMNITEC_COMMON_AREA_DELETE_SUCCESS = 'OMNITEC_COMMON_AREA_DELETE_SUCCESS'
export const OMNITEC_COMMON_AREA_DELETE_FAILURE = 'OMNITEC_COMMON_AREA_DELETE_FAILURE'

export const OMNITEC_EASYMS_CATEGORIES_FETCH_REQUEST = 'OMNITEC_EASYMS_CATEGORIES_FETCH_REQUEST'
export const OMNITEC_EASYMS_CATEGORIES_FETCH_SUCCESS = 'OMNITEC_EASYMS_CATEGORIES_FETCH_SUCCESS'
export const OMNITEC_EASYMS_CATEGORIES_FETCH_FAILURE = 'OMNITEC_EASYMS_CATEGORIES_FETCH_FAILURE'

export const OMNITEC_ENCODERS_FETCH_REQUEST = 'OMNITEC_ENCODERS_FETCH_REQUEST'
export const OMNITEC_ENCODERS_FETCH_SUCCESS = 'OMNITEC_ENCODERS_FETCH_SUCCESS'
export const OMNITEC_ENCODERS_FETCH_FAILURE = 'OMNITEC_ENCODERS_FETCH_FAILURE'

export const OMNITEC_ENCODERS_CREATE_REQUEST = 'OMNITEC_ENCODERS_CREATE_REQUEST'
export const OMNITEC_ENCODERS_CREATE_SUCCESS = 'OMNITEC_ENCODERS_CREATE_SUCCESS'
export const OMNITEC_ENCODERS_CREATE_FAILURE = 'OMNITEC_ENCODERS_CREATE_FAILURE'

export const OMNITEC_ENCODERS_DELETE_SUCCESS = 'OMNITEC_ENCODERS_DELETE_SUCCESS'
export const OMNITEC_ENCODERS_DELETE_FAILURE = 'OMNITEC_ENCODERS_DELETE_FAILURE'


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js